import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoAddress } from '@src/api/core/api-types';
import { createSimpleSliceReducers } from '../helpers/slice_helpers';

const initialState: RirekishoAddress = {
  zipCode: '',
  address: '',
  addressReading: '',
  areaCode: '',
  phoneNumber: '',
  callInfo: '',
};

const rirekishoAddressSlice = createSlice({
  name: 'rirekishoAddress',
  initialState,
  reducers: createSimpleSliceReducers<RirekishoAddress>(),
});

export const { update: updateRirekishoAddress } = rirekishoAddressSlice.actions;

export default rirekishoAddressSlice.reducer;
